import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-export-icon',
  templateUrl: './files-export.component.html'
})
export class FilesExportComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
